import React, { useEffect } from "react";
import Router from "./router";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  useEffect(() => {
    const found = document.querySelector('.Toastify__toast-container');
    console.debug('[App] ToastContainer present in DOM:', !!found, found);
  }, []);

  return (
    <>
      {typeof ToastContainer !== 'undefined' && ToastContainer ? (
        <ToastContainer position="top-right" autoClose={5000} />
      ) : null}
      <Router />
    </>
  );
}

export default App;

